import React from 'react';
import PropTypes from 'prop-types';
import { UniversalLink } from '@plone/volto/components';
import { flattenToAppURL, isInternalURL } from '@plone/volto/helpers/Url/Url';
import Component from '@plone/volto/components/theme/Component/Component';
import config from '@plone/volto/registry';
import { FormattedDate } from 'react-intl';
import { Icon } from 'semantic-ui-react';
import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';

const SummaryTemplate = ({
  items,
  linkTitle,
  linkHref,
  isEditMode,
  data = {},
}) => {
  let link = null;
  const href = linkHref?.[0]?.['@id'] || '';

  if (isInternalURL(href)) {
    link = (
      <ConditionalLink to={flattenToAppURL(href)} condition={!isEditMode}>
        {linkTitle || href}
      </ConditionalLink>
    );
  } else if (href) {
    link = <a href={href}>{linkTitle || href}</a>;
  }

  const buttonText = data?.customButtonText || 'Read more';

  return (
    <>
      <div className="items">
        {items.map((item) => {
          const hasType = item['@type'];
          const CustomItemBodyTemplate = config.getComponent({
            name: 'SummaryListingItemTemplate',
            dependencies: [hasType],
          }).component;

          const dateValue =
            item.created ||
            item.CreationDate ||
            item.effective ||
            item.EffectiveDate;

          const itemUrl = flattenToAppURL(item['@id']);

          const ItemBodyTemplate = () =>
            CustomItemBodyTemplate ? (
              <CustomItemBodyTemplate item={item} />
            ) : (
              <>
                <ConditionalLink item={item} condition={!isEditMode}>
                  <Component componentName="PreviewImage" item={item} alt="" />
                </ConditionalLink>

                <div className="listing-body">
                  {dateValue && (
                    <div className="listingItem__date">
                      <FormattedDate
                        value={new Date(dateValue)}
                        year="numeric"
                        month="long"
                        day="2-digit"
                      />
                    </div>
                  )}

                  <h3 className="listingItem__title">
                    {item.title ? item.title : item.id}
                  </h3>

                  {item.description && (
                    <p className="listingItem__description">
                      {item.description}
                    </p>
                  )}

                  {buttonText && (
                    <div className="listingItem__actions">
                      <span className="listingItem__cta">
                        <Icon name="caret right" />
                        <UniversalLink href={itemUrl}>
                          {buttonText}
                        </UniversalLink>
                      </span>
                    </div>
                  )}
                </div>
              </>
            );

          return (
            <div className="listing-item" key={item['@id']}>
              <ItemBodyTemplate item={item} />
            </div>
          );
        })}
      </div>

      {link && <div className="footer">{link}</div>}
    </>
  );
};

SummaryTemplate.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  linkTitle: PropTypes.any,
  linkHref: PropTypes.any,
  isEditMode: PropTypes.bool,
  data: PropTypes.object,
};

export default SummaryTemplate;
